// Campaign deep links (owner decision G7): `#lng,lat,zoom,pitch,bearing[,layer-id...]`.

import type { View } from "./config";

export interface HashState {
  view: View;
  layers: string[];
}

export function parseHash(hash: string): HashState | null {
  let parts: string[];
  try {
    parts = hash.replace(/^#/, "").split(",").map((p) => decodeURIComponent(p).trim());
  } catch {
    return null; // malformed percent-encoding
  }
  if (parts.length < 5) return null;
  const [lng, lat, zoom, pitch, bearing] = parts.slice(0, 5).map(Number);
  if (![lng, lat, zoom, pitch, bearing].every(Number.isFinite)) return null;
  if (Math.abs(lng) > 180 || Math.abs(lat) > 85 || zoom < 0 || zoom > 22) return null;
  const layers = parts.slice(5).filter((id) => /^[a-z0-9][a-z0-9-]*$/.test(id));
  return {
    view: { lng, lat, zoom, pitch: Math.min(85, Math.max(0, pitch)), bearing: normaliseBearing(bearing) },
    layers,
  };
}

/** Into [-180, 180). */
export const normaliseBearing = (b: number) => ((((b + 180) % 360) + 360) % 360) - 180;

export function formatHash({ view, layers }: HashState): string {
  const nums = [view.lng.toFixed(5), view.lat.toFixed(5), view.zoom.toFixed(2), Math.round(view.pitch), Math.round(view.bearing)];
  return `#${[...nums, ...layers].join(",")}`;
}

/** Ids from a hash that the manifest actually offers; anything else is ignored (atlas-map spec). */
export function honouredLayers(requested: string[], available: Iterable<string>): string[] {
  const ok = new Set(available);
  return [...new Set(requested)].filter((id) => ok.has(id));
}
